class NewsController {
  /* @ngInject */
  constructor($rootScope, $scope, $state, ApiService, HelperService) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = 'News';
      $rootScope.pageDescription = null;

      let bookmark = vm.news.bookmark;

      const setHeroField = (posts) =>
        posts.map((post) => {
          const heroField =
            post.fields.heroAssets && post.fields.heroAssets.length
              ? post.fields.heroAssets
              : post.fields.assets;
          post.hero = HelperService.group(heroField)[0];
          return post;
        });

      vm.news = setHeroField(vm.news.rows);

      function loadMore() {
        ApiService.entitySearch({
          q: 'schema:newsPost',
          children: 1,
          sort: '-sort.publishedAt<number>',
          limit: 10,
          bookmark,
        }).then((result) => {
          bookmark = result.bookmark;

          vm.news = vm.news.concat(setHeroField(result.rows));
        });
      }

      $scope.$on('nearBottom', loadMore);
    };
  }
}

export default NewsController;
